import { makeStyles } from '@mui/styles';

// colors
import { colors } from '../../../colors';

export const useStyles = makeStyles({
  root: {
    '& > ol': {
      display: 'flex',
      alignItems: 'center',
      '& > li > *': {
        fontWeight: 600,
        fontSize: 12,
        lineHeight: '16px',
        letterSpacing: '0.01em',
      },
      '& .MuiBreadcrumbs-separator': {
        padding: '0 15px',
        margin: 0,
      },
    },
  },
  separator: {
    width: 5,
    height: 9,
  },
  link: {
    color: colors.neutral500,
    fontSize: '14px !important',
  },
  text: {
    color: colors.neutral700,
    fontSize: '14px !important',
  },
  slash: {
    color: colors.neutral400,
    fontSize: '18px !important',
  },
});
